import React from 'react'
import { getString } from '../../../helpers/Functions'

const bookingColumn = name => {
  return (
    <div
      className={'BookingSchemeColumn'}
      style={{ backgroundColor: 'white', borderColor: 'white' }}
    >
      <h4 style={{ color: '#3b424d' }}>{name}</h4>
    </div>
  )
}

const BookingHeader = ({ laundries = [], laundryRules, language }) => {
  const { containerStyle, headerStyle } = styles
  const header =
    laundryRules.laundryType.toUpperCase() === 'S'
      ? getString('washhouse', language)
      : getString('laundryMachine', language)
  let laundryArray = []
  laundries.forEach(laundry => {
    laundryArray = [...laundryArray, bookingColumn(laundry.name)]
  })
  return (
    <div style={containerStyle}>
      <div style={headerStyle}>
        <h4 style={{ color: '#3b424d' }}>{header}</h4>
      </div>
      {laundryArray}
    </div>
  )
}

const styles = {
  containerStyle: {
    height: 64,
    backgroundColor: 'white',
    display: 'flex',
    flexDirection: 'row'
  },
  headerStyle: {
    minWidth: 200,
    height: 64,
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex'
  }
}

export { BookingHeader }



// WEBPACK FOOTER //
// ./src/components/common/bookingSchemeComponents/BookingHeader.js